import queryString from "query-string";
import { ensureArray } from "./objects";

export const queryStringToFilters = query => {
  const bits = queryString.parse(query);
  return {
    freetext: bits.freetext || "",
    offborders:
      bits.offborders === undefined ? false : bits.offborders === "true",
    districts: ensureArray(bits.districts).map(d => parseInt(d, 10)),
    categories: ensureArray(bits.categories).map(d => parseInt(d, 10)),
    active: bits.active
  };
};

export const filterToQueryString = filters => {
  const { districts, categories, freetext } = filters;

  const queryStr = queryString.stringify({
    districts: ensureArray(districts).join(","),
    categories: ensureArray(categories).join(","),
    freetext: freetext || "",
    offborders: filters.offborders === true ? "true" : "false"
  });
  return queryStr;
};



/** WEBPACK FOOTER **
 ** ./src/utils/filters.js
 **/